import { Navigate } from 'react-router';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_PLAY_BOARDS_PRO,
  ANY_SPORT_PLAY_EVENTTYPE,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { useLastVisitedEventType } from '#src/hooks/useLastVisitedEventType.ts';
import { isClassicOnlyEventTypeSport } from '#src/lib/so5.ts';

export const PlayPage = () => {
  const { generateSportContextPath, sport } = useSportContext();
  const { lastVisitedEventType } = useLastVisitedEventType();
  const {
    flags: {
      enableProCareerMode = {
        baseball: false,
        football: false,
        nba: false,
      },
    },
  } = useFeatureFlags();

  if (enableProCareerMode[sport.toLowerCase()]) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_PLAY_BOARDS_PRO)}
        replace
      />
    );
  }

  const eventType = isClassicOnlyEventTypeSport(sport)
    ? So5FixtureEvent.CLASSIC.toLowerCase()
    : lastVisitedEventType;

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_PLAY_EVENTTYPE, {
        params: {
          eventType,
        },
      })}
      replace
    />
  );
};

export default PlayPage;
